"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// imports
// import { get } from 'pkg-frontend-ajax'
var root = require("window-or-global");
var carol_1 = require("carol");
var iris_1 = require("iris");
var pkg_frontend_vuex_booking_general_1 = require("pkg-frontend-vuex-booking-general");
function initBooking(_a) {
    var commit = _a.commit, getters = _a.getters, dispatch = _a.dispatch;
    return __awaiter(this, void 0, void 0, function () {
        var cruise, persons, params, cruiseResponse, countriesResponse, formValidationsResponse, json, ccData;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    cruise = getters['generalCruise'];
                    persons = getters['persons/all'];
                    params = {
                        adults: persons.adults,
                        juveniles: persons.juveniles,
                        children: persons.children,
                    };
                    if (cruise.priceModel === 'VARIO' ||
                        cruise.priceModel === 'VARIOAI' ||
                        cruise.priceModel === 'PREMIUM' ||
                        cruise.priceModel === 'PREMIUMAI') {
                        params['priceModels'] = ['VARIO', 'VARIOAI', 'PREMIUM', 'PREMIUMAI'];
                    }
                    else {
                        params['priceModel'] = cruise.priceModel;
                    }
                    return [4 /*yield*/, iris_1.client.cruise(cruise.id, params)];
                case 1:
                    cruiseResponse = _b.sent();
                    return [4 /*yield*/, iris_1.client.countries(true)];
                case 2:
                    countriesResponse = _b.sent();
                    return [4 /*yield*/, carol_1.client.i18n()];
                case 3:
                    formValidationsResponse = (_b.sent()).messages.de.bea
                        .validation;
                    json = pkg_frontend_vuex_booking_general_1.convertBookingResponse(cruiseResponse, countriesResponse, formValidationsResponse);
                    // check if wrong cruise id or whatever
                    if (!json.cruise) {
                        if (root.location) {
                            if (root.location.hostname.indexOf('stage') == -1) {
                                root.location.href =
                                    'https://www.aida.de/kreuzfahrt/angebote-buchen.18527.html';
                            }
                            else {
                                root.location.href =
                                    'https://stage-www.aida.de/kreuzfahrt/angebote-buchen.18527.html';
                            }
                        }
                        return [2 /*return*/];
                    }
                    dispatch('pax/importFormValidations', json.formValidations);
                    dispatch('checkoutImportFormValidations', json.formValidations);
                    dispatch('checkoutImportPaymentCountries', json.paymentCountries);
                    dispatch('generalSetStaticData', json);
                    ccData = { index: 0, name: 'countryCode', value: 'DE' };
                    if (getters['generalCountries'].DE) {
                        dispatch('pax/setField', ccData);
                    }
                    dispatch('generalSetCruiseData', json);
                    dispatch('generalSetShipData', cruiseResponse.ships);
                    return [4 /*yield*/, dispatch('generalSetCruiseData', json)
                        // initial priceModel defines mandatory flight status
                    ];
                case 4:
                    _b.sent();
                    // initial priceModel defines mandatory flight status
                    if (getters['generalCruise'].mandatoryFlight[cruise.priceModel]) {
                        dispatch('transport/setType', 'flight');
                        commit('transport/SET_NONE_OPTION', false);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.initBooking = initBooking;
exports.default = {
    initBooking: initBooking,
};
//# sourceMappingURL=general_init.js.map